<script setup lang="ts">
import { MetalPlanData } from '@/page/domain/MetalPlanData';
import { InitialBannerPageData } from '@/page/domain/MetalPlanPageData';

const props = defineProps<{
  pageData: Partial<InitialBannerPageData>;
  plan: MetalPlanData;
  hideYear?: boolean;
}>();

</script>
<template>
  <div class="w-full bg-gradient-to-r from-blue-900 to-blue-500">
    <div class="flex flex-col max-w-7xl items-center mx-auto py-20 px-6 lg:px-3">
      <h1 class="text-center text-white font-bold">
        {{ hideYear ? '' : '2027 ' }} {{props.pageData.title}}
        <span v-if="plan.tierPrefix">{{ plan.tierPrefix }}&nbsp;</span>
        <span>{{ plan.tierName }}</span>
        <span v-if="!pageData.hidePlanTier && plan.tierNumber">&nbsp;{{ plan.tierNumber }}</span>
        <span v-if="plan.tierSuffix">&nbsp;{{ plan.tierSuffix }}</span>
        <span v-if="pageData.showPlansSuffix">&nbsp;Plans</span>
        <span v-if="pageData.subtitle">:</span>
      </h1>
      <h2 class="text-center font-bold" :class="pageData.subtitleColor" v-html="pageData.subtitle"></h2>
    </div>
  </div>
</template>
